import axios from "axios";
import Globais, { validateToken } from "../../components/Globais";
import {
  CidadeHospedagem,
  ConcluirEtapaPayload,
  FluxoApartamento,
  FluxoCota,
  FluxoResposta,
  PessoaResumo,
} from "./cadastroCotaUsuario.types";

export interface CadastroCotaUsuarioResumo {
  id: number;
  etapaAtual: string;
  concluidoEm?: string | null;
}

export interface PeriodoCotaUsuario {
  periodoUsuarioId: number;
  periodoId: number;
  checkIn: string;
  checkOut: string;
  editavel?: boolean;
  alugar?: number;
  trocar?: number;
  utilizar?: number;
}

export interface CadastroCotaUsuarioEmAndamento extends CadastroCotaUsuarioResumo {
  cotaUsuarioId: number | null;
  created_at: string;
  Empreendimento: {
    nome: string;
    CidadeTable: { nome: string; EstadoTab: { abreviacao: string } };
  } | null;
  Apto: { nome: string | null; capacidade: number | null } | null;
  Cota: { numeroCota: number | null } | null;
  CotaUsuario: {
    bloco: string | null;
    numeroApto: string | null;
    prioridade: string | null;
  } | null;
}

interface AssinaturaResumo {
  cotasUsuariosId?: number | null;
  cotaUsuarioId?: number | null;
  status?: string | null;
}

function getAuthConfig() {
  const token = validateToken();

  return token
    ? {
        headers: {
          Authorization: token.AuthStr,
        },
      }
    : undefined;
}

function extrairPessoaId(registro: any): number | null {

  console.log("Registro recebido para extração de pessoaId:", registro);
  const pessoaId =
    registro?.pessoaId ??
    registro?.Pessoa?.id ??
    registro?.PessoaTable?.id ??
    registro?.pessoa?.id;

  return pessoaId ? Number(pessoaId) : null;
}

export const cadastroCotaUsuarioApi = {
  async buscarApartamentos(empreendimentoId: number) {
    const response = await axios.get<FluxoApartamento[]>(
      `${Globais.DOMINIOBACK}/apto/info/${empreendimentoId}`,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarEmAndamento() {
    const response = await axios.get<CadastroCotaUsuarioEmAndamento[]>(
      `${Globais.DOMINIOBACK}/cadastro-cota-usuario/meus/em-andamento`,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarDestinosHospedagem() {
    const response = await axios.get<CidadeHospedagem[]>(
      `${Globais.DOMINIOBACK}/cidade/estados`,
      getAuthConfig()
    );

    return response.data;
  },

  async iniciarCadastro() {
    const response = await axios.post<FluxoResposta>(
      `${Globais.DOMINIOBACK}/cadastro-cota-usuario/fluxo/iniciar`,
      {},
      getAuthConfig()
    );

    return response.data;
  },

  async consultarFluxo(cadastroCotaUsuarioId: number) {
    const response = await axios.get<FluxoResposta>(
      `${Globais.DOMINIOBACK}/cadastro-cota-usuario/${cadastroCotaUsuarioId}/fluxo`,
      getAuthConfig()
    );
console.log(cadastroCotaUsuarioId, "Fluxo de cadastro consultado:", response.data);
    
    return response.data;
  },

  async buscarPorCotaUsuario(cotaUsuarioId: number) {
    const response = await axios.get<CadastroCotaUsuarioResumo>(
      `${Globais.DOMINIOBACK}/cadastro-cota-usuario/cotausuario/${cotaUsuarioId}`,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarPeriodosPorCotaUsuario(cotaUsuarioId: number) {
    const response = await axios.get<{ periodos?: PeriodoCotaUsuario[] }>(
      `${Globais.DOMINIOBACK}/cota-usuario/${cotaUsuarioId}`,
      getAuthConfig()
    );

    return response.data.periodos ?? [];
  },

  async concluirEtapa(
    cadastroCotaUsuarioId: number,
    payload: ConcluirEtapaPayload
  ) {
    const response = await axios.post<FluxoResposta>(
      `${Globais.DOMINIOBACK}/cadastro-cota-usuario/${cadastroCotaUsuarioId}/fluxo/concluir-etapa`,
      payload,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarPessoas() {
    const response = await axios.get<PessoaResumo[]>(
      `${Globais.DOMINIOBACK}/pessoas`,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarCotas() {
    const response = await axios.get<FluxoCota[]>(
      `${Globais.DOMINIOBACK}/cota`,
      getAuthConfig()
    );

    return response.data;
  },

  async buscarStatusAssinatura(cotaUsuarioId: number) {
    const response = await axios.get<AssinaturaResumo[]>(
      `${Globais.DOMINIOBACK}/assinatura`,
      getAuthConfig()
    );
    const assinatura = response.data.find(
      (item) =>
        Number(item.cotasUsuariosId ?? item.cotaUsuarioId) === cotaUsuarioId
    );

    return assinatura?.status ?? null;
 },

  async buscarPessoaIdDoUsuario(usuarioId: number) {
    try {
      const response = await axios.get(
        `${Globais.DOMINIOBACK}/usuario/${usuarioId}`,
        getAuthConfig()
      );
      const pessoaId = extrairPessoaId(response.data);

      if (pessoaId) {
        return pessoaId;
      }
    } catch {
      // Some user records do not expose Pessoa directly; use the list fallback.
    }

    const pessoas = await this.buscarPessoas();
    const pessoa = pessoas.find((item: any) => {
      const usuarioRelacionado =
        item?.usuarioId ??
        item?.Usuario?.id ??
        item?.UsuarioTable?.id ??
        item?.usuario?.id;

      return Number(usuarioRelacionado) === usuarioId;
    });

    return extrairPessoaId(pessoa);
  },
};
